import { SAVE_USER_AUTH, LOAD_USER_AUTH, LOGOUT_USER_AUTH } from '../const/authConst'

const initialState = {
  uid: null,
  role: null,
  sub_role: null,
  p_st: null,
  username: '',
  token: '',
  loggedIn: false,
  expires: null,
  course_id: null,
  authChecked: false,
}

export default function authReducer(state = initialState, action) {
  switch(action.type) {
    case SAVE_USER_AUTH:
      return {
        ...state,
        ...action.payload,
        authChecked: true,
      }

    case LOAD_USER_AUTH:
      return {
        ...state,
        ...action.payload,
        authChecked: true,
      }

    case LOGOUT_USER_AUTH:
      return {
        ...initialState,
        authChecked: true,
      }

    default:
      return state
  }
}
